export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14736.9f2021ac.jpg";